<template>
  <BackBar
    class="m-detail-top-header"
    :class="{
      fixed: changeText,
      live: live,
    }"
  >
    <h2 class="m-back-title">
      <keep-alive>
        <template v-if="changeText">
          <div class="teams flex animate__animated animate__fadeIn">
            <template v-if="isSpecial">
              <div class="m-league">
                <em>{{ event.category }}</em>
                {{ event.tournament }}
              </div>
            </template>
            <template v-else>
              <div class="m-team m-home-team">
                {{ event.homeTeam }}
              </div>
              <span class="m-vs">vs</span>
              <div class="m-team m-away-team">
                {{ event.awayTeam }}
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <span class="details animate__animated animate__fadeIn">Details</span>
        </template>
      </keep-alive>
    </h2>

    <div
      slot="right"
      class="right-container"
    >
      <a
        v-if="supportLink"
        slot="right"
        class="support-btn"
        :class="['animate__animated animate__fadeIn',{
          'ctrl-btn': changeText
        }]"
        :href="supportLink"
      >
        <keep-alive>
          <template v-if="changeText">
            <svg-icon
              class="animate__animated animate__fadeIn"
              icon-class="icon-help"
            />
          </template>
          <template v-else>
            <span class="animate__animated animate__fadeIn">How to play ?</span>
          </template>
        </keep-alive>
      </a>

      <div
        v-if="live"
        class="m-change-matches"
        :class="['animate__animated animate__fadeIn',{
          'ctrl-btn': changeText
        }]"
        @click="showChangeMatches"
      >
        <keep-alive>
          <template v-if="changeText">
            <InlineSvg
              class="icon-toggle animate__animated animate__fadeIn"
              icon="~public/images/inline/toggle.svg"
            />
          </template>
          <template v-else>
            <span class="animate__animated animate__fadeIn">Change Match
              <span class="m-icon animate__animated animate__fadeIn">
                <i class="m-icon-trangle down" />
              </span>
            </span>
          </template>
        </keep-alive>
      </div>
    </div>

    <slot />
  </BackBar>
</template>

<script>
import { checkESport } from '@ms/components/widgets/check.js'
import { prefixLink } from '@ms/config/app'
import BackBar from 'wap/components/BackBar'
import { transformCamelCase } from '@ms/utils/format'
import modalHelper from '@ms/utils/scroll-fixed'
import 'base/icons/svg/help.svg'

export default {
  name: 'TopHeader',
  components: {
    BackBar
  },
  model: {
    prop: 'visible',
    event: 'change-matches'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 是否是 live 比赛
    live: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: () => ({})
      // },
      // homeTeam: {
      //   type: String,
      //   default: ''
      // },
      // awayTeam: {
      //   type: String,
      //   default: ''
    },
    sportId: {
      type: String,
      default: ''
    },
    sport: {
      type: String,
      default: ''
    },
    changeText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    supportLink() {
      // 电竞显示 how to play 入口
      const { sportId } = this
      if (checkESport(sportId)) {
        // CS:GO
        const sport = sportId === 'sr:sport:109' ? 'counterStrike' : transformCamelCase(this.sport)
        return prefixLink(`/support/how-to-play/sports/${sport}`)
      }
      return undefined
    },
    isSpecial() {
      const { live, sportId } = this
      return live && (sportId === 'sr:sport:1' || sportId === 'sr:sport:2')
    }
  },
  beforeDestroy() {
    modalHelper.beforeClose()
  },
  methods: {
    showChangeMatches() {
      const visible = !this.visible
      if (!visible) {
        modalHelper.beforeClose()
      }
      this.$emit('change-matches', visible)
      if (visible) {
        modalHelper.afterOpen()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.right-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

[data-mode="light"] .m-details .m-detail-top-header.m-back-bar {
  background: #f8f8f8;
  color: #999;

  ::v-deep .m-back {
    color: #999;
  }

  .m-back-title {
    color: #000;
  }

  .m-change-matches {
    color: #000;
  }

  .m-icon .m-icon-trangle.down::before {
    border-top-color: #000;
  }

  &.fixed {
    box-shadow: none;
  }
}
</style>

<style lang="less" scoped>
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");
@import url("~base/style/animate.min.css");

.m-detail-top-header {
  position: sticky;
  z-index: 1001;
  top: 0;
  width: 100%;
  align-items: stretch;
  background: url("../../../components/Header/images/bg-header.png") no-repeat 0 -44px;
  background-size: 100% 90px;

  &.fixed {
    max-width: 750px;
    background:#1c1c1c;
  }

  .m-back-title {
    position: relative;
    height: 100%;
    font-size: 18px;

    .m-league {
      display: flex;
      align-items: center;
      font-size: 12px;
      .ellipsis();

      em {
        display: inline-block;
        margin-right: 8px;
        color: #999;
        font-family: Roboto;
        font-size: 12px;
      }
    }

    .m-vs {
      margin: 0 10px 0 6px;
      color: #999;
      font-size: 10px;
      font-weight: 400;
    }

    .m-team {
      max-width: 40vw;
      font-size: 14px;
      .ellipsis();
    }
  }

  &.live {
    .m-back-title {
      .m-team {
        max-width: 93/360*100vw;
      }
    }
  }

  .support-btn {
    flex: none;
    margin-left: 10px;
    color: #999;
    font-size: 12px;
  }

  .m-change-matches {
    margin-left: 10px;
    color: #fff;
    font-size: 14px;

    .icon-toggle {
      width: 16px;
      height: 16px;
    }
  }

  .teams {
    width: 100%;
  }

  .teams,
  .details {
    position: absolute;
  }

  .ctrl-btn {
    width: 40px;
    height: 44px;
    margin: 0;
    text-align: center;

    &:active {
      background: rgba(0, 0, 0, 30%);
    }

    .svg-icon {
      color: #fff;
      font-size: 18px;
    }
  }

  .m-icon {
    display: inline-block;
    width: 16px;
    height: 16px;

    .m-icon-trangle {
      transition: transform 0.2s linear;
      .m-icon-trangle(4px; #FFFFFF);

      &.active {
        transform: rotate(-90deg);
      }
    }
  }
}
</style>
